export const SITE = {
  brand: "SPJ Sporthorses",
  brandShort: "SPJ",
  location: "Coconut Creek, Florida",
  tagline:
    "Premium Czech Warmbloods, trained and brokered for the show ring.",
  email: "Stacey@spjsporthorses.com",
  phone: "(305) 000-0000",
  address: "Coconut Creek, Florida, USA",
  social: {
    instagram: "https://instagram.com/spjsporthorses",
    facebook: "#",
  },
};

export const HORSES = [
  {
    slug: "quincero",
    name: "Quincero",
    age: "4 years",
    color: "Dappled Grey",
    sex: "—",
    height: "—",
    discipline: "Hunter / Jumper Prospect",
    status: "Available",
    sire: "—",
    dam: "—",
    summary:
      "A striking 4-year-old dappled grey with a classic, modern type — uphill build, willing temperament, and the kind of presence that turns heads in the warm-up ring. Currently in light work and developing beautifully.",
    highlights: [
      "Quiet, trainable, and brave on a new line",
      "Naturally balanced canter with adjustable stride",
      "Well-suited for the amateur or junior coming up",
    ],
    image: "/quincero_portrait_0.jpg",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13814187/pexels-photo-13814187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
  about:
    "https://images.unsplash.com/photo-1756466167834-a1c231fb4c23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxlcXVlc3RyaWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3MjQ4NTMwfDA&ixlib=rb-4.1.0&q=85&w=1400",
  service_training:
    "https://images.unsplash.com/flagged/photo-1568381670226-fab8dc323343?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzaG93JTIwanVtcGluZyUyMGhvcnNlfGVufDB8fHx8MTc3NzI0ODUzMHww&ixlib=rb-4.1.0&q=85&w=1400",
  service_brokerage:
    "https://images.pexels.com/photos/9701117/pexels-photo-9701117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  service_coaching:
    "https://images.unsplash.com/photo-1574695272842-52dfdb7989d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxzaG93JTIwanVtcGluZyUyMGhvcnNlfGVufDB8fHx8MTc3NzI0ODUzMHww&ixlib=rb-4.1.0&q=85&w=1400",
  gallery: [
    {
      src: "https://images.pexels.com/photos/16464168/pexels-photo-16464168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=940",
      alt: "Elegant warmblood horse",
      span: "lg:col-span-4 lg:row-span-2",
      ratio: "aspect-[3/4]",
    },
    {
      src: "https://images.pexels.com/photos/32996824/pexels-photo-32996824.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      alt: "Rider and horse mid-jump",
      span: "lg:col-span-5",
      ratio: "aspect-[16/10]",
    },
    {
      src: "https://images.unsplash.com/photo-1581613388764-93221aa63faf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxzaG93JTIwanVtcGluZyUyMGhvcnNlfGVufDB8fHx8MTc3NzI0ODUzMHww&ixlib=rb-4.1.0&q=85&w=1200",
      alt: "Brown horse on green field",
      span: "lg:col-span-3",
      ratio: "aspect-square",
    },
    {
      src: "https://images.unsplash.com/photo-1640121326842-22232c103a73?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxiZWF1dGlmdWwlMjB3YXJtYmxvb2QlMjBob3JzZXxlbnwwfHx8fDE3NzcyNDg1MzB8MA&ixlib=rb-4.1.0&q=85&w=1200",
      alt: "Warmblood standing on lush field",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      src: "https://images.pexels.com/photos/9701117/pexels-photo-9701117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      alt: "Close-up of horse with rider",
      span: "lg:col-span-4",
      ratio: "aspect-[4/5]",
    },
    {
      src: "https://images.unsplash.com/flagged/photo-1568381670226-fab8dc323343?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzaG93JTIwanVtcGluZyUyMGhvcnNlfGVufDB8fHx8MTc3NzI0ODUzMHww&ixlib=rb-4.1.0&q=85&w=1400",
      alt: "Rider on horse",
      span: "lg:col-span-4",
      ratio: "aspect-[16/10]",
    },
  ],
};
